import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-order-or-lot-allocation-methods',
  templateUrl: './order-or-lot-allocation-methods.component.html',
  styleUrls: ['./order-or-lot-allocation-methods.component.css']
})
export class OrderOrLotAllocationMethodsComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.OrderOrLotAllocationMethods.columns;
    this.data = this.report.OrderOrLotAllocationMethods.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.OrderOrLotAllocationMethods.data;
    const gridInstance = this.gridContext.getInstance('OrderOrLotAllocationMethods');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/order-or-lot-allocation-methods/order-or-lot-allocation-methods.component.ts